export default "__VITE_ASSET__bf8ef8e3__"